import { dealsRequestConstructor } from '@monorepo/deals';
import { DealService } from '@spilca/order_ts/v1/order_web/deal_web_pb_service';

const getDeals = (filter: object | null) =>
  dealsRequestConstructor(filter, DealService.ListDeal);

export default getDeals;
